import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_MISSED_RECALL } from './missed-recall.reducer';

const reportsSelector = (appState: any) => appState[STORE_FEATURE_KEY_MISSED_RECALL];
const loadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_MISSED_RECALL].loading;

const fromDateSelector = (appState: any) => appState[STORE_FEATURE_KEY_MISSED_RECALL].fromDate;

@Injectable()
export class MissedRecallSelectors {
    constructor(private store: Store<any>) {
    }

    selectReports(): Observable<any> {
        return this.store
            .pipe(select(reportsSelector));
    }

    selectLoadingState(): Observable<boolean> {
        return this.store
            .pipe(select(loadingSelector));
    }

    selectFromDateState(): Observable<Date> {
        return this.store
            .pipe(select(fromDateSelector));
    }
}
